/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {saveUserAcknowledgedRiskAlert} from '../api'

export const useMutationSaveUserAcknowledgedRiskAlert = createReactQueryMutationHook('saveUserAcknowledgedRiskAlert', saveUserAcknowledgedRiskAlert)
